<div class="flex-control flex-column flex-height" *ngIf="admission || appointment">
  <app-payment-header class="flex-header" [appointment]="appointment" [admission]="admission"></app-payment-header>
  <app-payment-invoice class="flex-body flex-control flex-column" [appointment]="appointment" [admission]="admission" [appointment_from]="appointment_from" [isVisitCall]="isVisitCall"></app-payment-invoice>
</div>
